import { IBuildersProjectsData } from '../../types/buildersProjects';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EBuildersProjectsActionType, TSetBuildersProjectsData } from './types';

export const setBuildersProjectsData: (data: IBuildersProjectsData) => TSetBuildersProjectsData = actionGenerator<
  EBuildersProjectsActionType.SetData,
  IBuildersProjectsData
>(EBuildersProjectsActionType.SetData);
